<template>
    <div class="mizhi">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>幂之</span><span>金融数据平台</span>
                    </p>
                    <p>
                       幂之金融数据平台是集FOF投资分析管理和固收投资分析工具于一身的金融科技平台，以提升同业工作效率、改善同业工作生态、帮助同业提升业绩为终极目标。
                    </p>
                    <p>
                        <a href="https://matrix.sofund.com" target="_blank">
                            立即登录
                        </a>
                    </p>
                </div>
                <img src="../assets/mizhi-back-cp.png"
     srcset="../assets/mizhi-back-cp@2x.png 2x,
             ../assets/mizhi-back-cp@3x.png 3x" class="imgOne">

            </div>
        </div>
        <div class="second">
            <div class="web"> 
                <a href="https://matrix.sofund.com" target="_blank">
                    <p>
                       <img src="../assets/mizhi-back-web.png"
     srcset="../assets/mizhi-back-web@2x.png 2x,
             ../assets/mizhi-back-web@3x.png 3x">
                   </p>
                   <p>
                       <span>网页版</span> 
                   </p>
                </a>  
            </div>

            <div class="wechat">
                <p>
                       <img src="../assets/mizhi-back-wechat.png"
     srcset="../assets/mizhi-back-wechat@2x.png 2x,
             ../assets/mizhi-back-wechat@3x.png 3x">
                   </p>
                <p>
                    <span>微信小程序</span> 
                </p>
                <div class="code-wrapper">
                    <img src="../assets/mizhi-back-yellow.png"
     srcset="../assets/mizhi-back-yellow@2x.png 2x,
             ../assets/mizhi-back-yellow@3x.png 3x" class="yellow">
                    <img src="../assets/mizhi-back-code.png"
     srcset="../assets/mizhi-back-code@2x.png 2x,
             ../assets/mizhi-back-code@3x.png 3x" class="code">
                    <img src="../assets/matrix-wechat-mini.jpg" class="mini-code">

                </div>
                    

            </div>
            <div class="iOS">
                <p>
                       <img src="../assets/mizhi-back-ios.png"
     srcset="../assets/mizhi-back-ios@2x.png 2x,
             ../assets/mizhi-back-ios@3x.png 3x">
                   </p>
                <p>
                    <span>iOS版</span> 
                </p>
                <div class="code-wrapper">
                    <img src="../assets/mizhi-back-yellow.png"
     srcset="../assets/mizhi-back-yellow@2x.png 2x,
             ../assets/mizhi-back-yellow@3x.png 3x" class="yellow">
                    <img src="../assets/mizhi-back-code.png"
     srcset="../assets/mizhi-back-code@2x.png 2x,
             ../assets/mizhi-back-code@3x.png 3x" class="code">
                    <img src="../assets/matrix-iOS.png" class="mini-code">

                </div>
            </div>
        </div>
        <div class="three">
            <div class="content">
                <div>
                    <img src="../assets/mizhi-back-one.png"
     srcset="../assets/mizhi-back-one@2x.png 2x,
             ../assets/mizhi-back-one@3x.png 3x">
                    <p>
                        幂之金融数据平台提供专业的基金数据和资讯，并结合机器学习等高新技术制定筛选策略，辅助用户筛选优质投资标的。
                    </p>
                </div>
                <div>
                    <img src="../assets/mizhi-back-two.png"
     srcset="../assets/mizhi-back-two@2x.png 2x,
             ../assets/mizhi-back-two@3x.png 3x">
                    <p>
                        幂之金融数据平台可根据用户交易记录测算所投资基金组合的收益并进行分析，同时以丰富的可视化形式展现。
                    </p>
                </div>
                <div>
                    <img src="../assets/mizhi-back-three.png"
     srcset="../assets/mizhi-back-three@2x.png 2x,
             ../assets/mizhi-back-three@3x.png 3x">
                    <p>
                        基金池功能为用户提供投资标的初步筛选，根据投资者自定义的投资偏好、风控标准等筛选参数，建立备选投资标的的动态基金池,以便用户在此基础再进行后续的基金甄选。
                    </p>
                </div>
            </div>
        </div>
        <div class="four">
            <div class="content">
                <img src="../assets/mizhi-back-second.png"
     srcset="../assets/mizhi-back-second@2x.png 2x,
             ../assets/mizhi-back-second@3x.png 3x" class="imgOne">
                <div class="text">
                    <div class="content-first">
                        <p>
                            金融数据开放平台
                        </p>
                        <p>
                            定制化系统平台服务
                        </p>
                    </div>
                    <div class="content-second">
                        <p>
                            提供完善的API接口供用户使用，并提供二次开发服务实现特定化应用。
                        </p>
                        <p>
                            <a href="mailto:service@sofund.com">
                                联系合作
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Mizhi'
}
</script>

<style lang="scss">
.mizhi{
    min-width: 1000px;
    .first{
        min-height: 440px;
        margin-bottom: 177px;
        background: url("../assets/mizhi-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/mizhi-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/mizhi-back-first@3x.jpg") no-repeat center/cover;
        }
        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            position: relative;
            .text{
                width: 413px;
                margin-top: 147px;
                margin-left: 40px;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-bottom: 22px;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    width:357px;
                    font-size: 14px;
                    line-height: 1.86;
                }
                p:nth-child(3){
                    width: 230px;
                    text-align: center;
                    height: 48px;
                    margin-top: 37px;
                    line-height: 48px;
                    border-radius: 8px;
                    background-color: #064ec1;
                    a{
                        display: inline-block;
                        width: 230px;
                        text-align: center;
                        height: 48px;
                        color: #fff;
                    }
                }
            }
            img.imgOne{
                position: absolute;
                right: -140px;
                top: 130px;
            }
        }
    }
    .second{
        width: 730px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        margin-bottom: 78px;
        .web,.wechat,.iOS{
            text-align: center;
            font-size: 16px;
            color: #000;
            width: 210px;
            height: 112px;
            border-radius: 8px;
            box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.1);
            background-color: #fff;
            p{
                margin:0;
            }
            p:nth-child(1){
                margin-top:30px
            }
        }
        .web{
            a{
                text-decoration: none;
                color:#000;
            }
        }
        .wechat,.iOS{
            position: relative;
            cursor: pointer;
            .code-wrapper{
                .code{
                    position: absolute;
                    top: 9px;
                    right: 9px;
                }
                .mini-code{
                    background: #fff;
                    position: absolute;
                    display: none;
                    bottom: 0;
                    left: 45px;
                    max-width: 104px;
                }
                .yellow{
                    position: absolute;
                    top: 0;
                    right:0;
                }
            }
            &:hover .mini-code{
                display: block;
            }
        }
    }
    .three{
        background: #eceef3;
        width: 100%;
        height: 440px;
        overflow: hidden;
        .content{
           width: 1000px;
           margin: 0 auto;
           margin-top:75px;
           display: flex;
           justify-content: space-around;
           div{
               width: 270px;
               text-align: center;
               p{
                   margin-top:35px;
                   text-align: left;
                   font-size: 14px;
                   line-height: 1.86;
                   color: #333;
               }
           } 
        }
    }
    .four{
        width: 100%;
        overflow: hidden;
        .content{
            width: 1000px;
            height: 400px;
            margin: 0 auto;
            position: relative;
            .imgOne{
                margin-top: -350px;
                margin-left:-200px;
            }
            .text{
                position: absolute;
                left: 85px;
                top:100px;
                width: 1000px;
                display: flex;
                justify-content: space-between;
                overflow: hidden;
                .content-first{
                    width:330px;
                    margin-top: 25px;
                    p:nth-child(1){
                        font-size: 40px;
                        font-weight: bold;
                        line-height: 1;
                        color: #064ec1;
                    }
                    p:nth-child(2){
                        margin-top: 10px;
                        font-size: 20px;
                        line-height: 2;
                        color: #b0b0b0;
                    }
                }
                .content-second{
                    width: 240px;
                    margin-right: 215px;
                    p:nth-child(1){
                        font-size: 14px;
                        line-height: 1.71;
                        color: #000;
                    }
                    p:nth-child(2){
                        width: 230px;
                        text-align: center;
                        height: 48px;
                        margin-top: 37px;
                        line-height: 48px;
                        border-radius: 8px;
                        background-color: #064ec1;
                        a{
                            display: inline-block;
                            width: 230px;
                            text-align: center;
                            height: 48px;
                            color: #fff;
                        }
                    }
                }
            }
        }

    }
}
</style>